module.exports = __webpack_public_path__ + "c510271816bf9309a1c4670c84de6a10.pdf";